<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="depositsList"
        :search="search"
        class="elevation-1 pb-3"
        :loading="loading"
        :loading-text="$t('loadingData')"
        :no-data-text="$t('noDataText')"
        :no-results-text="$t('noResultsText')"
        :items-per-page="100"
        hide-default-footer
      >
        <template v-slot:top>
          <div class="row no-gutters d-flex align-center pa-3">
            <div
              v-if="depositsList && depositsList.length > 0"
              class="d-flex align-center"
            >
              <v-icon left>mdi-wallet</v-icon>
              <span>{{ totalDeposits }}</span>

              <span class="ml-2">
                {{ $tc("depositsPlurals", totalDeposits) }}
              </span>

              <v-progress-circular
                v-if="fetchingDeposits"
                indeterminate
                :size="20"
                color="primary"
                class="ml-2"
              ></v-progress-circular>
            </div>
            <v-spacer />
            <v-col cols="12" md="4" sm="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </div>
        </template>

        <template v-slot:[`item.player_id`]="{ item }">
          <v-btn @click="$copy(item.player_id)" x-small>
            {{ item.player_id }}
          </v-btn>
        </template>

        <template v-slot:[`item.player_phone`]="{ item }">
          {{ item.player_phone || "-" }}
        </template>

        <template v-slot:[`item.player_email`]="{ item }">
          {{ item.player_email || "-" }}
        </template>

        <template v-slot:[`item.deposit_id`]="{ item }">
          <v-btn @click="$copy(item.deposit_id)" x-small>
            {{ item.deposit_id }}
          </v-btn>
        </template>

        <template v-slot:[`item.player_register`]="{ item }">
          {{ $handleDate(item.player_register).date }}
        </template>

        <template v-slot:[`item.deposit_value`]="{ item }">
          <span class="green--text">{{ item.deposit_value }}</span>
        </template>

        <template v-slot:[`item.deposit_final_date`]="{ item }">
          {{ $handleDate(item.deposit_final_date).date }}
        </template>

        <template v-slot:[`item.deposit_status`]="{ item }">
          <v-chip small :class="handleDepositStatusUI(item.deposit_status)">
            {{ item.deposit_status }}
          </v-chip>
        </template>

        <template v-slot:[`item.affiliate_id`]="{ item }">
          <div v-if="item.affiliate_id == null">
            -
          </div>
          <v-btn v-else @click="$copy(item.affiliate_id)" x-small>
            {{ item.affiliate_id }}
          </v-btn>
        </template>

        <template v-slot:[`item.affiliate_name`]="{ item }">
          {{ item.affiliate_name || "-" }}
        </template>

        <template v-slot:[`item.local_id`]="{ item }">
          <div v-if="item.local_id == null">
            -
          </div>
          <v-btn v-else @click="$copy(item.local_id)" x-small>
            {{ item.local_id }}
          </v-btn>
        </template>

        <template v-slot:[`item.local_name`]="{ item }">
          {{ item.local_name || "-" }}
        </template>
      </v-data-table>
      <v-pagination
        v-if="pageCount > 0 && depositsList && depositsList.length > 0"
        v-model="page"
        :length="pageCount"
        :total-visible="7"
        class="pb-3"
      ></v-pagination>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "relatorio-apostas",
  data: (vm) => ({
    loading: false,
    fetchingDeposits: false,
    page: 1,
    pageCount: 0,
    timeoutId: 0,
    latestRangeDate: {},
    cachedPage: {},
    search: "",
    totalDeposits: 0,
    headers: [
      { text: vm.$t("depositID"), value: "deposit_id", align: "no-wrap" },
      { text: vm.$t("playerId"), value: "player_id", align: "no-wrap" },
      { text: vm.$t("name"), value: "player_name", align: "no-wrap" },
      { text: "DDD", value: "player_ddd", align: "no-wrap" },
      { text: vm.$t("phone"), value: "player_phone", align: "no-wrap" },
      { text: "Email", value: "player_email", align: "no-wrap" },
      { text: "CPF", value: "player_document", align: "no-wrap" },
      {
        text: vm.$t("registrationDate"),
        value: "player_register",
        align: "no-wrap",
      },
      { text: vm.$t("entryId"), value: "deposit_entrie", align: "no-wrap" },
      {
        text: vm.$t("consolidatedValue"),
        value: "deposit_value",
        align: "no-wrap",
      },
      {
        text: vm.$t("finishedIn"),
        value: "deposit_final_date",
        align: "no-wrap",
      },
      { text: vm.$t("provider"), value: "deposit_provider", align: "no-wrap" },
      { text: vm.$t("affiliateId"), value: "affiliate_id", align: "no-wrap" },
      {
        text: vm.$t("affiliateName"),
        value: "affiliate_name",
        align: "no-wrap",
      },
      { text: vm.$t("localManagerId"), value: "local_id", align: "no-wrap" },
      {
        text: vm.$t("localManagerName"),
        value: "local_name",
        align: "no-wrap",
      },
    ],
    depositsList: [],
  }),

  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    rangeDateHasChanged() {
      if (!this.latestRangeDate.data_inicio) return false;
      return (
        this.latestRangeDate.data_inicio != this.rangeDate.data_inicio ||
        this.latestRangeDate.data_final != this.rangeDate.data_final
      );
    },
  },

  mounted() {
    this.debouncedFetchTotalDepositsByRange();
  },

  watch: {
    rangeDate() {
      this.debouncedFetchTotalDepositsByRange();
    },
    saveFilters(bool) {
      bool && this.fetchDepositsReport();
    },
    page() {
      this.fetchDepositsReport(true);
    },
    totalDeposits(deposits) {
      if (deposits == 0) {
        this.depositsList = [];
      }
    },
  },

  methods: {
    debouncedFetchTotalDepositsByRange() {
      clearTimeout(this.timeoutId);
      const currentTimeout = setTimeout(() => {
        this.fetchTotalDepositsByRange();
      }, 500);
      this.timeoutId = currentTimeout;
    },

    async fetchTotalDepositsByRange() {
      this.fetchingDeposits = true;
      const body = {
        ...this.rangeDate,
      };
      await this.$axios
        .post(
          `${this.$prefix()}/players/countTotalDepositsByRange`,
          this.$formdata(body)
        )
        .then((response) => {
          this.totalDeposits = Number(response.data.dados.total_deposits);
          this.pageCount = Math.ceil(this.totalDeposits / 100);
          this.fetchingDeposits = false;
        })
        .catch(() => (this.fetchingDeposits = false));
    },
    async fetchDepositsReport(isChangingPage) {
      if (isChangingPage) {
        this.$store.commit("setGroupExport", "");
      }
      const body = {
        ...this.rangeDate,
        export: this.exportDoc,
      };

      if (this.exportDoc && !isChangingPage) {
        await this.$request.exportDoc(
          `${this.$prefix()}/players/depositsReport`,
          body,
          this.exportDoc,
          this.rangeDate
        );
        return;
      }

      body.page_number = this.page - 1;
      this.loading = true;
      this.depositsList = [];

      if (this.cachedPage[this.page] && !this.rangeDateHasChanged) {
        this.depositsList = this.cachedPage[this.page];
        this.loading = false;
        this.$store.commit("setFeedbackProgress", false);
        // this.$store.commit("setProgressLinear", false);
        this.$store.commit("setSave", false);
        this.$store.commit("DisabledSave", false);
        return;
      }

      await this.$request
        .post(`${this.$prefix()}/players/depositsReport`, body)
        .then((resp) => {
          this.depositsList = resp.dados;
          this.cachedPage[this.page] = this.depositsList;
          this.loading = false;
          this.latestRangeDate = { ...this.rangeDate };
        })
        .catch(() => (this.loading = false));
    },
  },
};
</script>
